// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip_tooltipContainer__-xJpI {
  position: relative;
  display: inline-flex;
}

.Tooltip_tooltipText__s7WyQ {
  visibility: hidden;
  width: 220px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -110px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 0.875rem;
  line-height: 1.4;
}

.Tooltip_tooltipContainer__-xJpI:hover .Tooltip_tooltipText__s7WyQ {
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/Tooltip.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".tooltipContainer {\n  position: relative;\n  display: inline-flex;\n}\n\n.tooltipText {\n  visibility: hidden;\n  width: 220px;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 8px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -110px;\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n.tooltipContainer:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `Tooltip_tooltipContainer__-xJpI`,
	"tooltipText": `Tooltip_tooltipText__s7WyQ`
};
export default ___CSS_LOADER_EXPORT___;
